import { Actions } from './actions.js';
const actionProps = {
    onItemClick: Actions.ITEM_CLICKED,
    onSuggestionClick: Actions.SUGGESTION_CLICKED,
    onSuggestionAdded: Actions.SUGGESTION_ADDED,
    onSuggestionRemoved: Actions.SUGGESTION_REMOVED,
    onKeyphraseChange: Actions.KEYPHRASE_CHANGED,
};
export default actionProps;
